import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "fish";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    fishGetCategory: [], //渔种分类
    fishGetCategoryName: [], //渔种名称
  },
  actions: {
    //饲料名称
    async getFeedNameList({ commit }, payload) {
      let result = await api.get(`/api/Product/Dropdown/${10001}`);
      return result.data;
    },
    //药品名称
    async getFishMedicineList() {
      let result = await api.get(`/api/Product/Dropdown/${10002}`);
      return result.data;
    },
    //疫苗名称
    async getPreventNameList() {
      let result = await api.get(`/api/Product/Dropdown/${10003}`);
      return result.data;
    },
    //基地下--饲料名称--增加
    async getFeedName({ commit }, payload) {
      let result = await api.get(`/api/Product/FeedDropdown/${payload}`);
      return result.data;
    },
    //基地下--药品名称--增加
    async getFishMedicine({ commit }, payload) {
      let result = await api.get(`/api/Product/PrecautionDropdown/${payload}`);
      return result.data;
    },
    //鱼苗采购-渔种
    async getFishList() {
      let result = await api.get(`/api/Product/Dropdown/${10000}`);
      return result.data;
    },
    //获取塘口下的渔种
    async getPondFishList(a, payload) {
      let result = await api.get(`/api/Fish/GetPurchaseFish/${payload}`);
      return result.data;
    },

    //获取分类渔种-塘口设置
    async getFishGetCategoryName({ commit }, payload) {
      let result = await api.get(`/api/Fish/${payload}
      `);
      if (result.status === 200) {
        commit("setFishGetCategoryName", result.data);
      }
      return result;
    },
    // 获取分类渔种下的渔种信息--塘口设置
    async getFishGetCategory({ commit }) {
      let result = await api.get("/api/Fish/GetCategory");
      if (result.status === 200) {
        commit("setFishGetCategory", result.data);
      }
      return result;
    },
    //根据条件搜索渔种---报表页面
    async getFishReport(a, payload) {
      let result = await api.get(`/api/Fish?${queryString.stringify(payload)}`);
      return result.data;
    },
  },
  mutations: {
    setFishGetCategory(state, payload) {
      state.fishGetCategory = payload;
    },
    setFishGetCategoryName(state, payload) {
      state.fishGetCategoryName = payload;
    },
  },
});

export default moduleName;
